import AsyncStorage from '@react-native-async-storage/async-storage';
import {apiRastrear} from './api';
import {getPersistentDeviceId} from '../utils/deviceId';

export const CIDADE_KEY = '@rastrear_cidade';
export const UF_KEY = '@rastrear_uf';

export const STATUS_BY_TIPO_LISTAGEM: Record<string, string> = {
  C: 'postos',
  G: 'gas',
  LA: 'lavagem',
  E: 'emplacamento',
  V: 'vistoria',
  P: 'pet',
  PA: 'prodAuto',
  M: 'multas',
  EP: 'emprestimo',
};

export const STATUS_BY_TIPO_PRODUTO: Record<string, string> = {
  G: 'detalhesGas',
  LA: 'detalhesLavagem',
  E: 'detalhesEmplacamento',
  V: 'detalhesVistoria',
  P: 'detalhesPet',
  PA: 'detalhesPAuto',
};

let _usuarioLogado = false;
let _geoOff = false;
let _clientId: string | null = null;
let _pendingCall: Promise<void> | null = null;

export function setRastrearLogado(logado: boolean) {
  _usuarioLogado = logado;
}

export function setRastrearGeoOff(geoOff: boolean) {
  _geoOff = geoOff;
}

export function setRastrearClientId(clientId: string | null) {
  _clientId = clientId;
}

interface RastrearParams {
  status_tela: string;
  cidade?: string | null;
}

export async function setCidadeRastrear(cidade: string) {
  if (cidade) {
    await AsyncStorage.setItem(CIDADE_KEY, cidade);
  }
}

export async function setUfRastrear(uf: string) {
  if (uf) {
    await AsyncStorage.setItem(UF_KEY, uf);
  }
}

export async function getUfRastrear() {
  return AsyncStorage.getItem(UF_KEY);
}

export async function rastrear(params: RastrearParams) {
  _pendingCall = (_pendingCall ?? Promise.resolve()).then(() => _rastrear(params));
  await _pendingCall;
}

async function _rastrear({status_tela, cidade}: RastrearParams) {
  try {
    const [cidadeStorage, device_id] = await Promise.all([
      AsyncStorage.getItem(CIDADE_KEY),
      getPersistentDeviceId(),
    ]);

    const cidadeFinal = cidade ?? cidadeStorage ?? (_geoOff ? 'geoOff' : null);

    await apiRastrear.post('/rastrear', {
      ...(cidadeFinal && {cidade: cidadeFinal}),
      ...(_clientId && {clientId: _clientId}),
      status_tela,
      logado: _usuarioLogado,
      device_id,
    });
  } catch {
    // silencioso: falha no rastreio não deve quebrar a tela
  }
}
